import { VendorBuyingAgreementRebateCategoryTiersGrowths } from '../../../components/Vendor';

export function BuyingAgreementRebateCategoryTiersGrowths() {
  return <VendorBuyingAgreementRebateCategoryTiersGrowths />;
}
